import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import PageHeader from "../components/app/PageHeader";

export default function Settings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      const { data } = await api.put("/settings", s);
      setS(data); setSaved(true); setTimeout(() => setSaved(false), 2500);
    } catch (e) { alert(formatApiError(e)); }
    finally { setSaving(false); }
  };

  if (!s) return <div className="p-10 font-mono text-xs" style={{ color: "var(--text-muted)" }}>Loading…</div>;

  return (
    <div data-testid="settings-page">
      <PageHeader
        eyebrow="Configuration"
        title="Settings"
        subtitle="Company info shown on quotes & PDFs, plus default rates used by the quote builder."
        actions={
          <button onClick={save} disabled={saving} data-testid="settings-save-btn" className="btn btn-primary">
            {saving ? "Saving…" : saved ? "Saved ✓" : "Save Changes"}
          </button>
        }
      />
      <div className="p-10 max-w-3xl space-y-6">
        <div className="surface p-6">
          <h3 className="font-display text-lg font-bold mb-5">Company</h3>
          <div className="space-y-4">
            <Field label="Company Name"><input value={s.company_name||""} onChange={(e) => setS({ ...s, company_name: e.target.value })} className="input" /></Field>
            <div className="grid grid-cols-2 gap-4">
              <Field label="ABN"><input value={s.company_abn||""} onChange={(e) => setS({ ...s, company_abn: e.target.value })} className="input" /></Field>
              <Field label="Phone"><input value={s.company_phone||""} onChange={(e) => setS({ ...s, company_phone: e.target.value })} className="input" /></Field>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Field label="Email"><input value={s.company_email||""} onChange={(e) => setS({ ...s, company_email: e.target.value })} className="input" /></Field>
              <Field label="Address"><input value={s.company_address||""} onChange={(e) => setS({ ...s, company_address: e.target.value })} className="input" /></Field>
            </div>
          </div>
        </div>

        <div className="surface p-6">
          <h3 className="font-display text-lg font-bold mb-5">Default Rates</h3>
          <div className="grid grid-cols-3 gap-4">
            <Field label="Labour Cost $/hr">
              <input type="number" step="0.5" value={s.default_labour_cost_rate} onChange={(e) => setS({ ...s, default_labour_cost_rate: parseFloat(e.target.value) || 0 })} className="input input-mono text-right" />
            </Field>
            <Field label="Labour Sell $/hr">
              <input type="number" step="0.5" value={s.default_labour_sell_rate} onChange={(e) => setS({ ...s, default_labour_sell_rate: parseFloat(e.target.value) || 0 })} className="input input-mono text-right" />
            </Field>
            <Field label="Default Wastage %">
              <input type="number" step="1" value={s.default_wastage_pct} onChange={(e) => setS({ ...s, default_wastage_pct: parseFloat(e.target.value) || 0 })} className="input input-mono text-right" />
            </Field>
          </div>
          <div className="text-xs font-mono mt-4" style={{ color: "var(--text-muted)" }}>
            GST rate: {(s.gst_rate * 100).toFixed(0)}% · controlled via env
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="label-eyebrow block mb-1.5">{label}</label>
      {children}
    </div>
  );
}
